import { __awaiter } from "tslib";
import { findAppDefinitionById } from '@office-start/m365-apps-service';
export class ExtensibilityAppInfoService {
    getApp(request) {
        return __awaiter(this, void 0, void 0, function* () {
            const appDefinition = yield findAppDefinitionById(request.id);
            if (!appDefinition) {
                return Promise.reject('App definition not found');
            }
            return {
                appDefinition: this.convertHarmonyAppDefinition(appDefinition),
            };
        });
    }
    convertHarmonyAppDefinition(harmonyAppDefinition) {
        let state = 'NotInstalled';
        switch (harmonyAppDefinition.acquisitionState) {
            case 'Acquired':
                state = 'Installed';
                break;
            case 'Unacquired':
                state = 'NotInstalled';
                break;
            case 'Blocked':
                state = 'Blocked';
                break;
            case 'NeedsConsentForUpgrade':
                state = 'RequireConsent';
                break;
            default:
                state = 'NotInstalled';
                break;
        }
        return {
            id: harmonyAppDefinition.id,
            name: harmonyAppDefinition.name,
            shortDescription: harmonyAppDefinition.shortDescription,
            smallImageUrl: harmonyAppDefinition.smallImageUrl,
            largeImageUrl: harmonyAppDefinition.largeImageUrl,
            accentColor: harmonyAppDefinition.accentColor,
            developerName: harmonyAppDefinition.developerName,
            isFullScreen: harmonyAppDefinition.isFullScreen,
            showLoadingIndicator: harmonyAppDefinition.showLoadingIndicator,
            state,
            composeExtensions: harmonyAppDefinition.composeExtensions,
            webApplicationInfo: harmonyAppDefinition.webApplicationInfo,
            validDomains: harmonyAppDefinition.validDomains,
        };
    }
}
//# sourceMappingURL=ExtensibilityAppInfoService.js.map